<template>
  <v-card>
    <v-card-text>
      <v-layout row>
       <v-component :is="renderCompanyFlags()" />
      <v-layout justify-end row wrap>
      <v-chip
        v-for="tag in tags"
        :key = tag.id
        small
        disabled
        text-color="secondary"
        @click="editNotesDialogOpen()"
        >
        <span class="text-xs-center">
        {{tag.name}}
        </span>
      </v-chip>
      </v-layout>
      </v-layout>
      <component :is="createNameComp(company)"/>
      <component :is="createNameShortComp(company)"/>
      <div>Дата создания: <b>{{formatDate(company.createDate)}}</b>
      </div>
      <span v-html="formatStatus(company.status)"></span>
      <div>
        <component :is="renderValueLink(formats.blank(getCompanyOgrn()), 'ОГРН', null, 'Копировать огрн')"/>
        <component :is="renderValueLink(formats.blank(getCompanyInn()), 'ИНН', null, 'Копировать инн', renderInnHtmlBold(company.inn))"/>
        <component :is="renderValueLink(formats.blank(getCompanyKpp()), 'КПП', null, 'Копировать кпп')"/>
      </div>
      <div>Численность: <b>{{company.staffNumber && company.staffNumber.value !== null? company.staffNumber.value : 'нет данных' }}</b> {{formatDateAt(company.staffNumber)}}</div>
      <div v-html="formatTaxMode(company.taxMode)"></div>
      <component :is="createAddressComp(company)"/>
      <component :is="createHeadsComp(company.heads, company.management)"/>
      <component v-if="company.management" :is="createManagementComp(company.management)"/>
      <div v-show="notesAvailable"><br/>
        <a @click="editNotesDialogOpen()">{{notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'}}</a>
        <div style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="notes"></div>
      </div>
      <div v-show="notesAvailable">
        <v-layout justify-begin row wrap>
        <v-chip
          small
          disabled
          text-color="secondary"
          @click="goDepo()"
          >
          <v-tooltip bottom open-delay="500">
            <span slot="activator">
             <v-icon>storage</v-icon>
            </span>
            <span>Перейти в депозитарий</span>
          </v-tooltip></span>
        </v-chip>
        <v-chip
          v-show="monitoring"
          small
          disabled
          text-color="secondary"
          @click="editNotesDialogOpen()"
          >
          <v-tooltip bottom open-delay="500">
            <span slot="activator">
             <v-icon>alarm</v-icon>
            </span>
            <span>Мониторинг включен</span>
          </v-tooltip></span>
        </v-chip>
        </v-layout>
      </div>
      <div v-show="notesAvailable"><br/>
        <a @click="editNotesDialogOpen()">{{privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'}}</a>
        <span style="white-space: pre-wrap; overflow-wrap: break-word;" v-html="privateNotes"></span>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-layout row wrap>
        <v-component :is="createCopyButton('Письмо', 'content_copy', 'Копировать для письма', getEmailHeaderReport)" />

        <v-component :is="createCopyButton('Преамбула 1', 'content_copy', 'Копировать для преамбулы договора вариант 1', getAgreementHeader1Report)" />

        <v-component :is="createCopyButton('Преамбула 2', 'content_copy', 'Копировать для преамбулы договора вариант 2', getAgreementHeader2Report)" />

        <v-component :is="createCopyButton('Реквизиты договора', 'content_copy', 'Копировать для реквизитов договора', getAgreementFooterReport)" />

        <v-component :is="createCopyButton('Конверт', 'content_copy', 'Копировать для конверта', getClientEnvelopeReport)" />
      </v-layout>
    </v-card-actions>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import apimix from '../common/apimix'
  import vNotesForm from './NotesForm'
  import dialogs from '../common/dialogs'
  import people from '../people/index.js'

  export default {
    name: 'v-company-panel',
    components: {},
    mixins: [apimix],
    data: () => ({
    }),
    props: {
      clientCompanyId: {
        type: Number,
        default: null
      },
      banks: {
        type: Array,
        default: []
      },
      company: {
        type: Object,
        default () {
          return this.getItemNew()
        }
      },
      monitoring: {
        type: Boolean,
        default: false
      },
      notesAvailable: {
        type: Boolean,
        default: false
      },
      notesEditable: {
        type: Boolean,
        default: false
      },
      privateNotes: {
        type: String,
        default: null
      },
      notes: {
        type: String,
        default: null
      },
      tags: {
        type: Array,
        default: null
      },
      otherAttribs: {
        type: Array,
        default () {
          return []
        }
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    created () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        getRefToUrl: 'getRefToUrl',
        getClientProfile: 'getClientProfile',
        getClientCompany: 'getClientCompany',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderStatus: 'renderStatus',
        renderFlags: 'renderFlags',
        renderUnreliableHtml: 'renderUnreliableHtml',
        renderReference: 'renderReference',
        renderEmployeeReference: 'renderEmployeeReference',
        getIconName: 'getIconName',
        getEmailHeaderReport: 'getEmailHeaderReport',
        getAgreementHeader1Report: 'getAgreementHeader1Report',
        getAgreementHeader2Report: 'getAgreementHeader2Report',
        getAgreementFooterReport: 'getAgreementFooterReport',
        getClientEnvelopeReport: 'getClientEnvelopeReport',
        renderCopyButton: 'renderCopyButton',
        renderContactButton: 'renderContactButton',
        renderValueLink: 'renderValueLink'
      })
    },
    methods: {
      formatDate (dateTime) {
        return formats.formatDate(dateTime)
      },
      formatDateAt (valueDTO) {
        if (!valueDTO ||
         (!valueDTO.created && !valueDTO.updated)) {
          return ''
        }
        var result = ''
        result = result.concat(
          '(на',
          '\xa0',
          valueDTO.created ? this.formatDate(valueDTO.created) : this.formatDate(valueDTO.updated),
         ')')
        return result
      },
      renderInnHtmlBold (inn) {
        return `<b>${this.renderInnHtml(inn)}</b>`
      },
      formatStatus (status) {
        return ''.concat(
          '<div>',
          'Статус в ЕГРЮЛ: ',
          this.renderStatus(status),
          '</div>'
          )
      },
      formatTaxMode (taxMode) {
        if (!taxMode || (!taxMode.isEnvd && !taxMode.isEshn && !taxMode.isUsn && !taxMode.isSpr)) {
          return ''
        }
        var arr = []
        if (taxMode.isUsn) {
          arr.push('Упрощенная система налогообложения (УСН)')
        }
        if (taxMode.isEnvd) {
          arr.push('Единый налог на вменённый доход (ЕНВД)')
        }
        if (taxMode.isSpr) {
          arr.push('Система налогообложения при выполнении соглашений о разделе продукции (СРП)')
        }
        if (taxMode.isEshn) {
          arr.push('Единый сельскохозяйственный налог (ЕСХН)')
        }
        return ''.concat(
          '<div>',
          'Налоговый режим: ',
          '<b>',
          arr.join(', '),
          '</b> ',
          this.formatDateAt(taxMode),
          '<div>'
        )
      },
      createNameComp (company) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
               <v-component :is="self.renderCopyButton('Копировать название', self.getCompanyNameFull)" />
               <v-component :is="self.createAddMonitoringButton()" />
            </div>
            <div>
             <span v-html="self.renderUnreliableHtml(dto)"></span>
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              company: company,
              dto: company.name,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании')
            },
            getCompanyNameFull () {
              return `${formats.getValue(self.company, ['name', 'value'])}`
            }
          }
        }
      },
      createNameShortComp (company) {
        return this.renderValueLink(formats.blank(this.getCompanyNameShort()), 'Сокращенное название:', null, 'Копировать название')
      },
      createAddressComp (company) {
        var self = this
        var template = ''.concat(
          `<div>
            <div>
              Адрес: <b><span v-html="getDto()"></span></b>
              {{self.renderDateSince(dto)}}
              <v-component :is="self.renderCopyButton('Копировать адрес', self.getCompanyAddress)" />

            </div>
            <div>
             <span v-html="self.renderUnreliableHtml(dto)"></span>
            </div>
           </div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              company: company,
              dto: company.address,
              formats: formats
            }
          },
          methods: {
            getDto () {
              return this.dto && this.dto.value ? this.dto.value : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об адресе компании')
            }
          }
        }
      },
      createHeadsComp (heads, management) {
        var self = this
        var template = `
        <div>
          <b v-if="(!heads || heads.length === 0) && !management">${formats.formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании')}</b>
          <template v-for="head in heads">
            <v-component :is="self.createEmployeeComp(head)"/>
          </template>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              heads: heads,
              management: management
            }
          }
        }
      },
      createEmployeeComp (employee) {
        var self = this
        var template = `
        <div>
        <div>
          {{employee.position}}
          <v-component :is="self.renderCopyButton('Копировать должность', getPosition)" /> :
        </div>
        <span v-html="self.renderEmployeeReference(employee)"></span>
        <b> ${self.formatHumanCountersHtml(employee.counters)} </b>
        <v-component :is="self.renderCopyButton('Копировать ФИО', getNameFull)" />
        <v-component :is="self.renderContactButton('Открыть контакт физического лица', openContact)" />
          <div>
            ИНН <b>${self.renderInnflHtml(employee.inn)}</b>
            <v-component :is="self.renderCopyButton('Копировать ИНН', getInn)" />
          </div>
          <div> ${self.renderDateSince(employee)}</div>
          <div> ${self.renderUnreliableHtml(employee)}</div>
          <div> ${self.formatDisqHtml(employee.disqualification)}</div>
          <div> ${self.formatDisqCountersHtml(employee.counters, employee.disqualification)}</div>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              employee: employee
            }
          },
          methods: {
            getPosition () {
              return self.getCompanyEmployeePosition(employee)
            },
            getNameFull () {
              return self.getCompanyEmployeeNameFull(employee)
            },
            getInn () {
              return self.getCompanyEmployeeInn(employee)
            },
            openContact () {
              let refCode = formats.getValue(self.company, ['reference', 'ref'])
              people.openByHuman(refCode, employee)
            }
          }
        }
      },
      createManagementComp (management) {
        var self = this
            // Агент: <v-component :is="self.renderReference(management.agent)" />
        var template = `
        <div>
          <div v-if="management.ref">
            Управляющая компания
            <v-flex> 
            <span v-html="self.renderReference(management.ref.value, '_blank')"></span>
            <span v-html="self.renderDateSince(management.ref)"></span>
            </v-flex>
            <v-flex v-if="management.refAddress"> Адрес: {{management.refAddress}}</v-flex>
            <v-flex v-if="management.refPhone"> Телефон: {{management.refPhone}}</v-flex>
          </div>
          <div v-if="management.agent">
            Агент: 
            span v-html="self.renderReference(management.agent.value, '_blank')"></span>
            <span v-html="self.renderDateSince(management.agent)"></span>
            <div v-if="management.agentPhone"> телефон: {{management.agentPhone}}</div> 
          </div>
          <div> ${self.renderUnreliableHtml(management)}</div>
        </div>          
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              management: management
            }
          }
        }
      },
      formatHumanCountersHtml (counters) {
        const _f = v => v !== null ? v : 'нет данных'
        if (!counters) {
          return '<div></div>'
        }
        var result = ''.concat(
          `<v-tooltip bottom>`,
          `<span slot="activator">`,
          `<v-icon small>${this.getIconName('head')}</v-icon>${_f(counters.managedCompaniesExact)}(${_f(counters.managedCompaniesGeneral)})&nbsp`,
          `<v-icon small>${this.getIconName('holder')}</v-icon>${_f(counters.sharedCompaniesExact)}(${_f(counters.sharedCompaniesGeneral)})`,
          `<v-icon small>${this.getIconName('loner')}</v-icon>${_f(counters.loners)}`,
          `</span>`,
          `<span>Управление и участие в компаниях, наличие ИП <br/> точное (не точное) совпадение</span>`,
          `</v-tooltip>`
          )
        return result
      },
      formatDisqHtml (disq) {
        if (!disq) {
          return ''
        }
        return formats.formatErrorHtml(`Дисквалифиция с ${this.formatDate(disq.fromDate)} по ${this.formatDate(disq.toDate)} решение от ${this.formatDate(disq.decisionDate)}`)
      },
      formatDisqCountersHtml (counters, disq) {
        if (counters.disqualificationsGeneral) {
          if ((counters.disqualificationsGeneral > 1) || (!disq && counters.disqualificationsGeneral > 0)) {
            return formats.formatWarningHtml(`Найдены дисквалификации в других компаниях!`)
          }
        }
        return ''
      },
      createCopyButton (caption, icon, hint, action) {
        var template = ''.concat(
          `<div><v-tooltip bottom open-delay="500">
            <div slot="activator">
              <v-btn  small flat  @click="self.copyToClipboard(action)">
                <v-icon small>{{icon}}</v-icon>{{caption}}
              </v-btn>
            </div>
            <span>{{hint}}</span>
          </v-tooltip></div>`
        )
        var self = this
        return {
          template: template,
          data: function () {
            return {
              caption: caption,
              icon: icon,
              hint: hint,
              action: action,
              self: self
            }
          }
        }
      },
      getCompanyNameFull () {
        return `${formats.getValue(this.company, ['name', 'value'])}`
      },
      getCompanyNameShort () {
        return `${formats.getValue(this.company, ['nameShort'])}`
      },
      getCompanyOgrn () {
        return `${formats.getValue(this.company, ['ogrn'])}`
      },
      getCompanyInn () {
        return `${formats.formatInn(formats.getValue(this.company, ['inn']))}`
      },
      getCompanyKpp () {
        return `${formats.getValue(this.company, ['kpp'])}`
      },
      getCompanyAddress () {
        return `${formats.getValue(this.company, ['address', 'value'])}`
      },
      getCompanyEmployeePosition (employee) {
        console.log('getCompanyEmployeePosition', employee)
        return `${formats.getValue(employee, ['position'])}`
      },
      getCompanyEmployeeNameFull (employee) {
        return `${formats.getValue(employee, ['nameFull'])}`
      },
      getCompanyEmployeeInn (employee) {
        return `${formats.formatInnfl(formats.getValue(employee, ['inn']))}`
      },
      createAddMonitoringButton () {
        var template = ''.concat(
          `<span v-show="!self.monitoring"><v-tooltip bottom open-delay="500">
            <span slot="activator">
              <v-btn style="margin:0" small icon @click="onClick">
                <v-icon small>{{icon}}</v-icon>
              </v-btn>
            </span>
            <span>{{hint}}</span>
          </v-tooltip></span>`
        )
        var self = this
        return {
          template: template,
          data: function () {
            return {
              icon: 'alarm_add',
              hint: 'Включить мониторинг',
              self: self
            }
          },
          methods: {
            onClick () {
              let refCode = formats.getValue(self.company, ['reference', 'ref'])
              if (refCode) {
                self.$store.dispatch('updateMonitoringCompanies', {refCodes: [refCode], monitoring: true})
                self.$emit('refresh')
              }
            }
          }
        }
      },
      copyToClipboard (template) {
        const action = (template, company, clientCompany, companyInfo, clientInfo) => {
          var text = company ? template(company, clientCompany, companyInfo, clientInfo) : ''
          this.$store.dispatch('copyToClipboard', {text: text})
        }
        Promise.resolve().then(() => {
          if (this.company.heads && this.company.heads.length > 0 && this.company.heads[0].inn) {
            return people.findIndividualByInn(this.company.heads[0].inn)
          } else {
            return null
          }
        }).then((individual) => {
          let bank = this.banks && this.banks.length > 0 ? this.banks.sort((a, b) => formats.compareString(a.name, b.name))[0] : null
          let companyInfo = {
            isRefreshed: true,
            email: null,
            phone: null,
            bankDetails: {
              account: bank ? bank.bankAccount : null,
              bankName: bank ? bank.bankName : null,
              corrAccount: bank ? bank.bankCorrAccount : null,
              bankBic: bank ? bank.bankRcbic : null
            }
          }
          if (individual && individual.contacts && individual.contacts.length > 0) {
            let contacts = individual.contacts.filter(c => this.company.inn === c.companyInn)
            if (contacts.length === 0) {
              contacts = individual.contacts
            }
            companyInfo.email = contacts[0].email
            companyInfo.phone = contacts[0].phone
          }
          return companyInfo
        }).then((ci) => {
          action(template, this.company, this.getClientCompany, ci, this.getClientProfile)
        })
      },
      editNotesDialogOpen: function (item) {
        if (!this.notesEditable) {
          return
        }
        var self = this
        const setNotes = function (data) {
          // if (self.notes || self.notes && self.notes.localeCompare(data) !== 0) {
          self.$emit('refresh')
          // }
        }
        dialogs.register('v-notes-form', vNotesForm)
        var comp = { template: `
          <v-notes-form v-on:input="setNotes" v-on:close="$emit('close')" :fullscreen="fullscreen" :model="model"></v-notes-form>
        `,
          data () {
            return {
              model: {clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.company, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring},
              setNotes: setNotes,
              fullscreen: self.$vuetify.breakpoint.xsOnly
            }
          }
        }
        dialogs.modal(comp)
      },
      goDepo: function () {
        let tag = `#${formats.getValue(this.company, ['reference', 'ref'])}`
        this.$router.push({path: '/doc_list/root', query: {tag: [tag]}})
      },
      renderCompanyFlags () {
        return this.company ? this.renderFlags(this.company.flags, false) : null
      },
      createComp (template) {
        return formats.createComp(template)
      },
      getItemNew () {
        return {
          ref: null,
          ogrn: null,
          ogrnDate: null,
          releaseDate: null,
          inn: null,
          kpp: null,
          nameShort: '',
          name: '',
          address: '',
          clientId: null,
          activities: [],
          head: {
            position: '',
            lastName: '',
            firstName: '',
            middleName: ''
          }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// CompanyPanel.vue?73420255